/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HostNameApiIdApiKeyData } from './HostNameApiIdApiKeyData';
import {
    HostNameApiIdApiKeyDataFromJSON,
    HostNameApiIdApiKeyDataFromJSONTyped,
    HostNameApiIdApiKeyDataToJSON,
    HostNameApiIdApiKeyDataToJSONTyped,
} from './HostNameApiIdApiKeyData';

/**
 * 
 * @export
 * @interface ZboziIntegrationInput
 */
export interface ZboziIntegrationInput {
    /**
     * 
     * @type {Array<HostNameApiIdApiKeyData>}
     * @memberof ZboziIntegrationInput
     */
    hostNameApiIdApiKeyList?: Array<HostNameApiIdApiKeyData>;
}

/**
 * Check if a given object implements the ZboziIntegrationInput interface.
 */
export function instanceOfZboziIntegrationInput(value: object): value is ZboziIntegrationInput {
    return true;
}

export function ZboziIntegrationInputFromJSON(json: any): ZboziIntegrationInput {
    return ZboziIntegrationInputFromJSONTyped(json, false);
}

export function ZboziIntegrationInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): ZboziIntegrationInput {
    if (json == null) {
        return json;
    }
    return {
        
        'hostNameApiIdApiKeyList': json['hostNameApiIdApiKeyList'] == null ? undefined : ((json['hostNameApiIdApiKeyList'] as Array<any>).map(HostNameApiIdApiKeyDataFromJSON)),
    };
}

export function ZboziIntegrationInputToJSON(json: any): ZboziIntegrationInput {
    return ZboziIntegrationInputToJSONTyped(json, false);
}

export function ZboziIntegrationInputToJSONTyped(value?: ZboziIntegrationInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hostNameApiIdApiKeyList': value['hostNameApiIdApiKeyList'] == null ? undefined : ((value['hostNameApiIdApiKeyList'] as Array<any>).map(HostNameApiIdApiKeyDataToJSON)),
    };
}

